import { capitalCase } from 'capital-case';
import React from 'react';
import Avatar from 'src/components/10-atoms/avatar/Avatar';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import useUserStorage from 'src/modules/authentication/storage/user/hook';
import useI18n from 'src/modules/translations/hooks/useI18n';
import SidebarItem from './SidebarItem';
const ProfileSidebarItem = ({ focused }) => {
    const { translate } = useI18n();
    const [userDetails] = useUserStorage();
    const label = userDetails
        ? capitalCase(userDetails.firstName || userDetails.lastName || translate('Profile'))
        : translate('Profile');
    return (React.createElement(SidebarItem, { prefix: "User_", label: label, to: { screen: 'User_Home', params: {} }, focused: focused, renderIcon: (color, size) => userDetails ? (React.createElement(Avatar, { size: "xxs", uri: userDetails.avatarURL })) : (React.createElement(FeatherIcon, { name: "user", color: color, size: size })) }));
};
export default ProfileSidebarItem;
